import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView    from "./TemplateListView";
import JobAdminDetailsView from "./JobAdminDetailsView";
import JobAdminNewView     from "./JobAdminNewView";


const JobAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState({});
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      name: t("I18N_Name"),
      sortable: true,
      sortField: 'name',
      grow: 2.5,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2.5,
      wrap: true
    },
    {
      name: t("I18N_Service"),
      selector: row => row.service,
      grow: 1.5,
      wrap: true,
      sortable: true,
      sortField: 'service'
    },
    {
      name: t("I18N_Recurrence"),
      selector: row => row.recurrence
    },
    {
      name: t("I18N_Frequency"),
      selector: row => row.frequency,
      right: true,
      grow: 0.5
    },
    {
      name: t("I18N_State_setting"),
      grow: 0.5,
      selector: row => t("I18N_" + row.stateSetting),
      sortable: true,
      sortField: 'stateSetting'
    },
    {
      name: t("I18N_Status"),
      grow: 0.5,
      selector: row => t("I18N_" + row.status),
      sortable: true,
      sortField: 'status'
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API} apiObjName={'jobs'}
                                                  listPageTitle={t("I18N_Job_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_job")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Job_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_job")}
                                                  tableColumns={tableColumns}
                                                  primaryIdColType={'NAME'}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <JobAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <JobAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default JobAdmin;
